import { createFileRoute } from '@tanstack/react-router';
import { ReportExplorerPage } from '../features/reporting/reportExplorer/components/ReportExplorerPage';
import { createDefaultAgencyReportExplorerConfiguration } from '../features/reporting/reportExplorer/reportRequest';
import { ReportExplorerScope } from '../features/reporting/reportExplorer/reportEnums';
import {
  reportExplorerRouteSearchSchema,
  parseReportExplorerRouteSearch,
} from '../features/reporting/reportExplorer/reportExplorerRouteSearch';
import { useSavedReportQuery } from '../features/reporting/savedReports/hooks';
import { SavedReportSource } from '../features/reporting/savedReports/model';
import { SavedReportPresetSelect } from '../features/reporting/savedReports/components/SavedReportPresetSelect';
import { savedReportToExplorerConfiguration } from '../features/reporting/savedReports/savedReportConfiguration';
import { dashboardT } from '../lib/messages';

export const Route = createFileRoute('/a/$agencyId_/reporting/report-explorer')({
  validateSearch: reportExplorerRouteSearchSchema,
  component: AgencyReportRoute,
});
function AgencyReportRoute() {
  const { agencyId } = Route.useParams();
  const search = Route.useSearch();
  const saved = useSavedReportQuery(search.savedReportId, search.savedReportSource, agencyId);
  if (
    search.savedReportId &&
    search.savedReportSource &&
    (saved.isLoading || !saved.data || saved.isError)
  ) {
    return (
      <main className="p-6">
        {dashboardT(saved.isLoading ? 'savedReports.runLoading' : 'savedReports.runError')}
      </main>
    );
  }
  let initialConfiguration = parseReportExplorerRouteSearch(
    search,
    undefined,
    createDefaultAgencyReportExplorerConfiguration(),
  );
  if (saved.data) initialConfiguration = savedReportToExplorerConfiguration(saved.data);
  return (
    <ReportExplorerPage
      key={`${agencyId}-${search.savedReportSource ?? ''}-${search.savedReportId ?? ''}`}
      scope={ReportExplorerScope.Agency}
      agencyId={agencyId}
      initialConfiguration={initialConfiguration}
      initialSavedReport={
        search.savedReportSource === SavedReportSource.Owned ? saved.data : undefined
      }
      savedReportPicker={
        <SavedReportPresetSelect
          agencyId={agencyId}
          savedReportId={search.savedReportId}
          savedReportSource={search.savedReportSource}
        />
      }
    />
  );
}
